const clarityInit = id => {
    (function (c, l, a, r, i, t, y) {
        c[a] =
            c[a] ||
            function () {
                (c[a].q = c[a].q || []).push(arguments);
            };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", id);
}

class Clarity {
  constructor() {
    if (!window.clarity) {
      throw new Error("Clarity is not initialized");
    }
  }

  static init(id) {
    clarityInit(id);
  }

  static hasStarted() {
    return typeof window.clarity === "function";
  }

  identify(userId, properties) {
    window.clarity("identify", userId, properties);
  }

  consent(value = true) {
    window.clarity("consent", value);
  }

  stop() {
    window.clarity("stop");
  }

  start() {
    window.clarity("start");
  }

  setTag(key, value) {
    window.clarity("set", key, value);
  }

  setEvent(name) {
    window.clarity("event", name);
  }

  upgrade(reason) {
    window.clarity("upgrade", reason);
  }
}

export default Clarity;